import { render, staticRenderFns } from "./CloverSetting.vue?vue&type=template&id=6fc00768&"
import script from "./CloverSetting.vue?vue&type=script&lang=js&"
export * from "./CloverSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports